import { gatewayApiClient } from '../../_shared/api/gatewayApiClient';
import type { PageResponse } from '../../_shared/types/shared';
import type { ConsumerGroupRow, ConsumerGroupFormValues, ConsumerGroupFilters } from '../types/consumerGroup';

export const consumerGroupsApi = {
  list: async (params: ConsumerGroupFilters & { page: number; size: number; sort?: string }) => {
    const response = await gatewayApiClient.get<PageResponse<ConsumerGroupRow>>('/admin/consumer-groups', { params });
    return response.data;
  },

  get: async (id: string) => {
    const response = await gatewayApiClient.get<ConsumerGroupRow>(`/admin/consumer-groups/${id}`);
    return response.data;
  },

  create: async (body: ConsumerGroupFormValues) => {
    const response = await gatewayApiClient.post<ConsumerGroupRow>('/admin/consumer-groups', body);
    return response.data;
  },

  replace: async (id: string, body: ConsumerGroupFormValues) => {
    const response = await gatewayApiClient.put<ConsumerGroupRow>(`/admin/consumer-groups/${id}`, body);
    return response.data;
  },

  delete: async (id: string) => {
    await gatewayApiClient.delete(`/admin/consumer-groups/${id}`);
  },
};
